export const Translations_EN = {
	footer: {
		join: "Join this discussion now. No app or login required.",
		climate: "A Climate Positive Discussion.",
		tree: "This tree was planted.",
		start: "Start video discussions for free.",
	},
};
